import * as activities from './Activities';
import * as banks from './Banks';
import * as companies from './Companies';
import * as vendors from './Vendors';
import * as serviceCategories from './ServiceCategories';
import * as provided from './Provided';
import * as membership from './Membership';
import * as ticketAssignee from './TicketAssignees';
import * as brands from './Brands';
import * as categoires from './Categories';

export const route = {
  path: 'preferences',
  children: [
    activities.route,
    banks.route,
    companies.route,
    vendors.route,
    serviceCategories.route,
    provided.route,
    ticketAssignee.route,
    membership.route,
    brands.route,
    categoires.route,
  ],
};
